<template>
  <div class='third'>
    <div class='phone'>已绑定手机号：{{user.userMobile}}</div>
    <div class='email'>
      <p class='first'>邮箱：
        <span v-if='user.userEmail'>{{user.userEmail}}</span>
        <span v-else>未绑定</span>
        <el-button size='small' v-if='!user.userEmail' @click='bindEmail'>绑定</el-button>
         <el-button size='small' v-if='user.userEmail' @click='bindEmail'>修改</el-button>
      </p>
      <p class='second'>绑定邮箱可用于接收系统发送的通知邮件或其它安全验证</p>
    </div>

    <div class='email wxBind'>
      <p class='first'>微信绑定：
        <span v-if='user.wxUserBindFlag === 1'>已绑定</span>
        <span v-else>未绑定</span>
        <el-button size='small' v-if='user.wxUserBindFlag === 2' @click='bindWechat'>绑定</el-button>
        <el-button size='small' v-if='user.wxUserBindFlag === 1' @click='unBindWechat'>解绑</el-button>
      </p>
      <p class='second'>绑定微信号可用微信直接登录</p>

      <div class='wxCode' v-show="wechatLogin">
        <i class="el-icon-circle-close-outline close" @click='wechatLogin = false'></i>
        <div id="qrCode"></div>
      </div>
    </div>
    <div class='email wxBind'>
      <p class='first'>短信提醒：
        <el-switch
          @change='saveAlert(1)'
          v-model='msgAlert'
          active-text="开启"
          inactive-text="关闭"
          >
        </el-switch>
      </p>
    </div>
    <div class='email wxBind'>
      <p class='first'>微信提醒：
        <el-switch
          @change='saveAlert(2)'
          v-model='wxAlert'
          active-text="开启"
          inactive-text="关闭">
        </el-switch>
      </p>
    </div>
    <div class='corps' v-show='user.bindCorpInfo.corpNameAcronym || user.bindParkInfo.length || user.platformManagerFlag === 1'>
      <p>已绑定的平台/园区/企业：</p>
      <!-- 企业 -->
      <p class='bind_corp' v-show='user.bindCorpInfo.corpNameAcronym'>
         <span>{{user.bindCorpInfo.corpNameAcronym}}</span>
         <el-button size='small' @click='unBindCropAsk(user.bindCorpInfo.corpId)'>解绑</el-button>
      </p>

      <!-- 园区 -->
      <div class="park" v-show='user.bindParkInfo.length'>
        <p class='bind_park' v-for="(park, index) in user.bindParkInfo" :key='index'>
          <span>{{park.parkNameAcronym}}</span>
          <el-button size='small' @click='unBindParkAsk(park.parkId, index)'>解绑</el-button>
        </p>
      </div>

      <!-- 平台 -->
      <p class='bind_paltform' v-show='user.platformManagerFlag === 1'>
         <el-button size='small' @click='unBindPlatformAsk'>解绑平台</el-button>
      </p>

    </div>
    <!-- 绑定邮箱 -->
    <div class='mask' v-show='showMaskFlag'>
      <div class='container'>
        <el-form ref="call" :rules="emailRules" :model="call" class='call_form' label-width='80px' size='small'>
          <el-form-item>
            <h1>绑定邮箱</h1>
          </el-form-item>
          <el-form-item label='邮箱' prop='email'>
            <el-input v-model="call.email"></el-input>
          </el-form-item>
          <el-form-item class='btngroup'>
            <el-button size='mini' class='cancel' @click='cancelbindEmail'>取消</el-button>
            <el-button size='mini' class='confirm' @click='submitBindEmail'>提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 验证手机 -->
    <div class="valideMobileMask" v-show='validateMobileFlag'>
      <div class="container">
        <h1 class='title'>绑定手机</h1>
        <i class='el-icon-circle-close-outline close' @click='resetValid'></i>
        <el-form ref="valideRules" :model="valideUser" class='valid_form' :rules="valideRules" label-width="100px" :label-position="'left'" size='small'>
          <el-form-item prop='mobile' label="手机号">
            <el-input placeholder="请填写手机号" v-model="valideUser.mobile"></el-input>
          </el-form-item>
          <el-form-item  prop="accessCode" class="access_code" label='验证码'>
            <template slot-scope="scope">
                <el-input v-model="valideUser.accessCode"></el-input>
                <el-button @click="sendAccessCode" :disabled="!stop">{{access_msg}}</el-button>
            </template>
          </el-form-item>
          <el-form-item>
            <el-button class='bindwx' @click="valideMobile">绑定手机</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import deepcopy from '@/utils/deepcopy';
import taUrl from '@/static/backstageUrl';
import config from '@/static/config';

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      const valid = /^(\w){8,}$/.test(value);
      if (value && !valid) {
        callback(new Error('密码仅接收数字、字母、下划线'));
      } else {
        callback();
      }
    };
    const validatePass1 = (rule, value, callback) => {
      const valid = /^(\w){8,}$/.test(value);
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!valid) {
        callback(new Error('密码仅接收数字、字母、下划线'));
      } else {
        if (this.pass.password2 !== '') {
          this.$refs.registuser.validateField('password2');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      const valid = /^(\w){8,}$/.test(value);
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!valid) {
        callback(new Error('密码仅接收数字、字母、下划线'));
      } else if (value !== this.pass.password1) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    const validateEmail = (rule, value, callback) => {
      if (value && !/^[A-Za-z1-9][A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]{2,}[-.])+[A-Za-z\d]{2,5}([-.][A-Za-z\d]{2,})*$/.test(value)) {
        callback(new Error('邮箱格式错误!'));
      } else {
        callback();
      }
    };
    // 验证手机
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        return;
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value)) {
        callback(new Error('手机号格式错误!'));
      } else if (value !== this.user.userMobile) {
        callback(new Error('必须绑定当前登录账号!'));
      } else {
        callback();
      }
    };
    const validateAccessCode = (rule, value, callback) => {
      if (value && !/^\d{6}$/.test(value)) {
        callback(new Error('验证码仅接受6位数字!'));
      } else {
        callback();
      }
    };
    return {
      msgAlert: false,
      wxAlert: false,
      wechatLogin: false,
      validateMobileFlag: false,
      isAgreeUserprotocol: false,
      valideUser: {
        mobile: '',
        accessCode: '',
      },
      valideRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' },
        ],
        accessCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { validator: validateAccessCode, trigger: 'blur' },
        ],
      },
      timer: 60,  // 默认倒数60秒
      stop: true,  // 默认是停止的
      Interval: null, // setInterval的对象
      ukey: '', // 扫码后获得的wxCode换取的ukey，用于绑定手机号

      pass: {
        password: '',
        password1: '',
        password2: '',
      },
      registRules: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '密码至少8位', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
        ],
        password1: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '密码至少8位', trigger: 'blur' },
          { validator1: validatePass, trigger: 'blur' },
        ],
        password2: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '密码至少8位', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' },
        ],
      },
      emailRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' },
        ],
      },
      submitSuccessFlag: false,
      tips: {
        title: '提示',
        tipsMsg: '提交成功！等待企业与您联系。',
        duration: 2000,
      },
      showMaskFlag: false,
      call: {
        email: '',
      },
    };
  },
  methods: {
    ...mapMutations(['change_user', 'change_token']),
    modify() {
      this.$refs.registuser.validate((valid) => {
        if (valid) {
          this.modifyHttp();
        } else {
          return false;
        }
      });
    },
    modifyHttp() {
      this.$http.post(`${this.URL_PREFIX}/app/modify/user/info/password`, {
        oldPassword: this.MD5(this.pass.password),
        newPassword: this.MD5(this.pass.password1),
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        this.submitSuccessFlag=true;
        if (res.resCode === '10000') {
          this.tips.tipsMsg = '密码修改成功';
        } else {
          this.tips.tipsMsg = res.resDesc;
        }
        this.$refs.registuser.resetFields();
      });
    },
    bindEmail() {
      this.showMaskFlag = true;
    },
    cancelbindEmail() {
      this.resetEmail();
    },
    submitBindEmail() {
      this.$refs.call.validate((valid) => {
        if (valid) {
          this.conformBindEmail();
        } else {
          return false;
        }
      });
    },
    conformBindEmail() {
      this.$http.post(`${this.URL_PREFIX}/app/added/user/send/email`, {
        ...this.call,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.tips.tipsMsg = '验证链接已发送至邮箱，请登录邮箱完成验证！';
        } else {
          this.tips.tipsMsg = res.resDesc;
        }
        this.submitSuccessFlag=true;
      });
      this.resetEmail();
    },
    successMsg() {
      this.$message({
        message: '保存成功',
        type: 'success'
      });
    },
    errorMsg() {
      this.$message({
        message: '保存失败',
        type: 'success'
      });
    },
    // 绑定微信
    bindWechat(){
      // this.change_path(this.$route.path);
      // this.$router.push('/navigator/auth/login?type=wx');
      this.wechatLogin = true;
      let load = require('load-script');
      load('https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js', {}, ()=>{
        window.WxLogin({
          self_redirect:false,
          id:"qrCode",
          appid: config.wechatWebsiteAppId,
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent(`${taUrl.pcUrl}/navigator/auth/bindWechat`),
          state: "",
          style: "",
          href: ""
        });
      });
    },
    // 保存提醒
    saveAlert(e) {
      this.$http.post(`${this.URL_PREFIX}/app/modify/user/info/notice/switch`, {
        type: e,
        smsNotice: this.msgAlert ? 1 : 2,
        wechatNotice: this.wxAlert ? 1 : 2,
      },{
        headers: { token: this.token }
      }).then((response) => {
        if(response.data.resCode==="10000"){
          this.user.smsNotice = this.msgAlert ? 1 : 2 ;
          this.user.wechatNotice = this.wxAlert ? 1 : 2 ;
          this.change_user(this.user);
          this.successMsg();
        }
        else
          this.errorMsg();
      })
    },
    // 解绑微信
    unBindWechat() {
      this.$confirm(`确定解绑微信?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.unBindWechatRequest();
      }).catch(()=> {});
    },
    unBindWechatRequest() {
      this.$http.post(`${this.URL_PREFIX}/app/unbind/user/quick/auth/account`, {
        type: 1,
      }, {
        headers: { token: this.token }
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.tips.tipsMsg = '解绑成功';
          const user = deepcopy(this.user);
          user.wxUserBindFlag = 2;
          this.change_user(user);
        } else {
          this.tips.tipsMsg = res.resDesc;
        }
        this.submitSuccessFlag=true;
      });
    },
    resetEmail() {
      this.showMaskFlag = false;
      this.$refs.call.resetFields();
    },
    // 解绑企业
    unBindCrop(id) {
      this.$http.post(`${this.URL_PREFIX}/app/unbind/user/info/manage`, {
        type: 3,
        corpId: id,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.tips.tipsMsg = '解绑成功';
          this.user.bindCorpInfo = {};
          const user = deepcopy(this.user);
          user.bindCorpInfo = {};
          this.change_user(user);
        } else {
          this.tips.tipsMsg = res.resDesc;
        }
        this.submitSuccessFlag=true;
      });
    },
    unBindCropAsk(id) {
      this.$confirm(`确定解绑企业?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.unBindCrop(id);
      }).catch(()=> {});
    },
    // 解绑园区
    unBindPark(id, index) {
      this.$http.post(`${this.URL_PREFIX}/app/unbind/user/info/manage`, {
        type: 2,
        parkId: id,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.tips.tipsMsg = '解绑成功';
          this.user.bindParkInfo.splice(index, 1);
          this.change_user(this.user);
        } else {
          this.tips.tipsMsg = res.resDesc;
        }
        this.submitSuccessFlag=true;
      });
    },
    unBindParkAsk(id, index) {
      this.$confirm(`确定解绑园区?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.unBindPark(id, index);
      }).catch(()=> {});
    },
    // 解绑平台
    unBindPlatform() {
      this.$http.post(`${this.URL_PREFIX}/app/unbind/user/info/manage`, {
        type: 1,
      }, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.tips.tipsMsg = '解绑成功';
          this.user.platformManagerFlag = 2;
          this.change_user(this.user);
        } else {
          this.tips.tipsMsg = res.resDesc;
        }
        this.submitSuccessFlag=true;
      });
    },
    unBindPlatformAsk(id) {
      this.$confirm(`确定解绑平台?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.unBindPlatform();
      }).catch(()=> {});
    },

    // 以下为验证手机

    // 扫码成功的回调
    scanCallback() {
      this.wechatLogin = false;
      this.$http.post(`${this.URL_PREFIX}/app/user/login/wx/scan`, {
        wxCode: this.code,
      }).then((response) => {
        const res = response.data;
        // 需要绑定手机
        if(res.resCode === '20301'){
          this.ukey = res.resData.ukey;
          this.validateMobileFlag = true;
        } else if (res.resCode === '10000') {
          // 微信登陆成功
          this.getUserInfo(res.resData.token);
        } else if(res.resCode === '99999'){
          // wxCode无效
          this.tips.tipsMsg = '获取微信信息失败，请重试';
          this.submitSuccessFlag = true;
        } else {
          // 其他错误
          this.tips.tipsMsg = res.resDesc;
          this.submitSuccessFlag = true;
        }
      });
    },
    runTimer() {
      if (this.timer <= 0) {
        this.timer = 60;
        this.stop = true;
        clearInterval(this.Interval);
      } else {
        this.timer -= 1;
      }
    },
    startTimer() {
      // 如果是false就开始倒计时，如果是true就停止倒计时
      if (!this.stop) {
        this.Interval = setInterval(this.runTimer, 1000);
      } else {
        clearInterval(this.Interval);
      }
    },
    sendAccessCode() {
      this.$refs.valideRules.validateField('mobile', (error) => {
        if (error) {
          return;
        }
        // 手机号正确的处理
        this.stop = false;
        this.startTimer();
        this.$http.post(`${this.URL_PREFIX}/app/added/user/send/sms`, {
          userMobile: this.valideUser.mobile,
          smsType: 6,
        }).then((response) => {
          const res = response.data;
          if (res.resCode !== '10000') {
            this.tips.tipsMsg = res.resDesc;
            this.submitSuccessFlag = true;
          }
        });
      });
    },
    valideMobile() {
      this.$refs.valideRules.validate((valid) => {
        if (valid) {
          this.registHttp();
        } else {
          return false;
        }
      });
    },
    // httpRequest
    registHttp() {
      let data = {
        type: 1,
        ukey: this.ukey,
        userMobile: this.valideUser.mobile,
        validateCode: this.valideUser.accessCode,
      };

      this.$http.post(`${this.URL_PREFIX}/app/quick/auth/user/register`, data).then((response) => {
        const res = response.data;

        if (res.resCode === '10000') {
          this.tips.tipsMsg = '绑定成功';
          this.submitSuccessFlag = true;
          this.getUserInfo(res.resData.token);
        } else {
          this.tips.tipsMsg = res.resDesc;
          this.submitSuccessFlag = true;
        }
        this.resetValid();
      });
    },
    getUserInfo(token) {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {}, { headers: { token: token } }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.change_token(token);
          this.change_user(res.resData);
        }
      });
    },
    // 关闭验证手机框
    resetValid() {
      this.validateMobileFlag = false;
      this.valideUser.mobile = '';
      this.valideUser.accessCode = '';
    },
  },
  computed: {
    ...mapGetters(['user', 'token']),
    access_msg() {
      return this.stop ? '发送验证码' : `${this.timer}秒后可重新发送`;
    },
  },
  created() {
    window.getCode = (code) => {
      this.code = code;
      this.scanCallback();
    };

  },
  mounted() {
    this.msgAlert = this.user.smsNotice==1 ? true : false;
    this.wxAlert = this.user.wechatNotice==1 ? true : false;
  }
};
</script>

<style lang="scss" scoped>
@import '~@scss';
.third{
  padding: 30px;
  .phone{
    color: #333333;
    line-height: 48px;
    border-bottom: 1px solid #f2f2f2;
  }
  .email{
    padding: 30px 0;
    border-bottom: 1px solid #f2f2f2;
    color: #333333;
    &.wxBind{
      position: relative;
      .wxCode{
        position: absolute;
        z-index: 30;
        background: #fff;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid #ccc;
        .close{
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 20px;
          cursor: pointer;
        }
      }
      .el-switch__core:after {
          content: "";
          position: absolute;
          top: 1px;
          left: 1px;
          border-radius: 100%;
          transition: all .3s;
          width: 16px;
          height: 16px;
          background-color: #fff !important;
      }
    }
    .first{
      position: relative;
      font-weight: 500;
      line-height: 32px;
      .el-switch{
        position: absolute;
        right: 0;
        top: 6px;

      }
      .el-button{
        position: absolute;
        right: 0;
        top: 5px;
        padding: 4px 8px;
        font-size: 12px;
        background: #d0011b;
        color: #ffffff;
      }
    }
    .second{
      font-size: 12px;
      color: #666666;
    }
  }
  .corps{
    padding: 30px 0;
    border-bottom: 1px solid #f2f2f2;
    .bind_corp{
      position: relative;
      font-weight: 500;
      line-height: 32px;
      .el-button{
        position: absolute;
        right: 0;
        top: 5px;
        padding: 4px 8px;
        font-size: 12px;
        background: #d0011b;
        color: #ffffff;
      }
    }
    .bind_park{
      position: relative;
      font-weight: 500;
      line-height: 32px;
      .el-button{
        position: absolute;
        right: 0;
        top: 5px;
        padding: 4px 8px;
        font-size: 12px;
        background: #d0011b;
        color: #ffffff;
      }
    }
    .bind_paltform{
      position: relative;
      line-height: 32px;
      height: 32px;
      .el-button{
        position: absolute;
        right: 0;
        top: 5px;
        padding: 4px 8px;
        font-size: 12px;
        background: #d0011b;
        color: #ffffff;
      }
    }
  }
  .password{
    padding-top: 30px;
    p{
      line-height: 48px;
      color: #333333;
    }
    .modify{
      background: #d0011b;
      color: #ffffff;
    }
  }
  .submit-success{
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .valideMobileMask{
    @include mask;
    .close{
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 20px;
      cursor: pointer;
    }
    .title{
      margin-bottom: 20px;
      text-align: center;
    }
    .el-form{
      .el-form-item{
        min-width: 400px;
        &.access_code{
          .el-form-item__content{
            .el-input{
              width: 100px;
            }
            .el-button{
              position: absolute;
              right: 0;
              bottom: 0;
            }
          }
        }
        &:last-of-type{
          margin-bottom: 0;
        }
        .bindwx{
          background: $color-main;
          color: #fff;
          border-color: $color-main;
        }
      }
    }
  }
}

.mask{
@include mask;
  .container{
    width: 80%;
    max-width: 400px;
    .call_form{
      .btngroup{
        text-align: center;
      }
      .cancel, .confirm{
        padding: 8px 40px;
      }
      .cancel{
        color: #d0011b;
        border-color: #d0011b;
      }
      .cancel:hover{
        background: #d0011b;
        color: #FFFFFF;
        border-color: #d0011b;
      }
      .confirm{
        background: #d0011b;
        color: #FFFFFF;
        border-color: #d0011b;
      }
      .confirm:hover{
        background: #ffffff;
        color: #d0011b;
        border-color: #d0011b;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/navigator/personal/components/info/child/Third.vue